import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Crown, User, LogOut, Shield } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import './Navbar.css';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => { logout(); navigate('/'); };

  const planColor = { free: '#7a7a9d', basic: '#00a3ff', pro: '#7c3aed', premium: '#00ff88' }[user?.plan] || '#7a7a9d';

  return (
    <nav className="navbar">
      <Link to="/dashboard" className="nav-brand">⚡ Zip2Extract <span>AI</span></Link>
      <div className="nav-items">
        <Link to="/dashboard" className={`nav-item ${location.pathname === '/dashboard' ? 'active' : ''}`}>
          <LayoutDashboard size={16} /> Dashboard
        </Link>
        <Link to="/premium" className={`nav-item ${location.pathname === '/premium' ? 'active' : ''}`}>
          <Crown size={16} /> Upgrade
        </Link>
        {user?.isAdmin && (
          <Link to="/admin" className="nav-item"><Shield size={16} /> Admin</Link>
        )}
      </div>
      <div className="nav-end">
        <div className="nav-plan" style={{ color: planColor, borderColor: planColor + '40' }}>
          {user?.plan?.toUpperCase()}
        </div>
        <Link to="/profile" className="nav-avatar">
          {user?.name?.[0]?.toUpperCase() || user?.email?.[0]?.toUpperCase() || 'U'}
        </Link>
        <button className="nav-logout" onClick={handleLogout} title="Logout">
          <LogOut size={16} />
        </button>
      </div>
    </nav>
  );
}
